import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReloadCache } from 'src/app/core/decorators/reload-cache.decorator';
import { StoreCacheKeys } from 'src/app/core/enums';
import { AbstractRestService } from '../../../../core/services/AbstractRestService';
import { IAuditorium, ICopyAuditoriumPayload, ICxCashPosition, ISeatsPlan, ISector, ISectorPayload } from '../../interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuditoriumsApiService extends AbstractRestService<IAuditorium> {

  protected readonly basePath = '/auditoriums';

  public updateAuditoriumPlanningGap(auditoriumId: number, planningGap: number): Observable<void> {
    return this.apiService.post(`${this.basePath}/${ auditoriumId }/set-planning-gap?planningGap=${ planningGap }`);
  }

  @ReloadCache<IAuditorium>(StoreCacheKeys.GetMyAuditoriums)
  @ReloadCache<IAuditorium>(StoreCacheKeys.GetMyCinemasWithAuditoriums)
  @ReloadCache<IAuditorium>(StoreCacheKeys.GetAuditoriumTypes)
  public override create(obj: IAuditorium): Observable<IAuditorium> {
    return super.create(obj);
  }

  @ReloadCache<IAuditorium>(StoreCacheKeys.GetMyAuditoriums)
  @ReloadCache<IAuditorium>(StoreCacheKeys.GetMyCinemasWithAuditoriums)
  @ReloadCache<IAuditorium>(StoreCacheKeys.GetAuditoriumTypes)
  public override update(id: number, obj: IAuditorium): Observable<IAuditorium> {
    return super.update(id, obj);
  }

  public copyAuditorium(
    auditoriumId: number,
    payload: ICopyAuditoriumPayload
  ): Observable<IAuditorium> {
    return this.apiService.post(`${this.basePath}/${ auditoriumId }`, payload);
  }

  public override getAll(cinemaId?: string | number, archived?: boolean): Observable<IAuditorium[]> {
    const params = cinemaId ? { cinemaId } : {};

    if (archived !== undefined && archived !== null) {
      params['archived'] = archived;
    }

    return this.apiService.get(`${ this.basePath }/all`, params);
  }

  public createSector(auditoriumId: number, payload: ISectorPayload): Observable<ISeatsPlan> {
    return this.apiService.post(`${this.basePath}/${auditoriumId}/sectors`, payload);
  }

  public getAuditoriumSectors(auditoriumId: number, parentSectorId?: number, archived?: boolean): Observable<ISector[]> {
    const params = parentSectorId ? { parentSectorId } : {};

    if (archived !== undefined && archived !== null) {
      params['archived'] = archived;
    }

    return this.apiService.get(`${ this.basePath }/${ auditoriumId }/sectors/all`, params);
  }

  public archiveAuditorium(auditoriumId: number, archive: boolean): Observable<void> {
    return this.apiService.post(`${ this.basePath }/${ auditoriumId }/archive?archive=${ archive }`);
  }

  public getDefaultCXCashPosition(): Observable<ICxCashPosition> {
    return this.apiService.get(`${ this.basePath }/default-cx-cash-position`);
  }

  @ReloadCache<void>(StoreCacheKeys.GetMyAuditoriums)
  @ReloadCache<void>(StoreCacheKeys.GetMyCinemasWithAuditoriums)
  @ReloadCache<void>(StoreCacheKeys.GetAuditoriumTypes)
  public migrateAuditoriumConfiguration(
    sourceConfigurationId: number,
    targetConfigurationId: number
  ): Observable<void> {
    return this.apiService.post(
      `${this.basePath}/configurations/${sourceConfigurationId}/migrate/${targetConfigurationId}`
    );
  }
}
